// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"5c0950c1","806":"33e58ae7"}[chunkId] + ".chunk.js";
};